import { create } from 'zustand';

type InstructionsGuideState = {
  open: boolean;
  openGuide: () => void;
  closeGuide: () => void;
};

export const useInstructionsGuideStore = create<InstructionsGuideState>((set) => ({
  open: false,
  openGuide: () => set({ open: true }),
  closeGuide: () => set({ open: false }),
}));
